import React from 'react'
import Modal from 'react-modal'

import AccommodationDetails from './ModalComponents/AccommodationDetails'

import '../../styles/scss/elements/accommodation-details-modal.scss'

Modal.setAppElement('#ylg-ms__featured-accommodations')

const AccommodationDetailsModal = ({ accommodation, isOpen, onClose }) => {
  return (
    <Modal
      id="accommodation-modal"
      parentSelector={() => document.getElementById('ylg-ms__featured-accommodations')}
      isOpen={isOpen}
      onRequestClose={onClose}
      contentLabel="My dialog"
      overlayClassName="ylg-ms__featured-accommodations__accommodation-details-modal-overlay"
      className="ylg-ms__featured-accommodations__accommodation-details-modal"
    >
      <AccommodationDetails
        accommodation={accommodation}
        onClose={onClose}
      />
    </Modal>
  )
}

export default AccommodationDetailsModal
